import { render, staticRenderFns } from "./single-draft-container.vue?vue&type=template&id=99b82d68&"
import script from "./single-draft-container.vue?vue&type=script&lang=js&"
export * from "./single-draft-container.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports